import { computed, watch, WatchHandle } from 'vue'

import { useCallSessionRoomStore } from '@/entities/call-session'
import { useStoreConferenceMediaStatuses } from '@/entities/conference-participant'
import { useStoreMediaDevices } from '@/entities/media-devices'
import { RTCSessionFacade, eventBus } from '@/entities/webrtc'

import { deactivateLocalAudioStream } from '../lib'

export const useDeactivateLocalMicStream = (facade: RTCSessionFacade) => {
  const { getParticipantMediaStatus } = useStoreConferenceMediaStatuses()
  const storeMediaDevices = useStoreMediaDevices()

  const { callId, localAudioStream, isOnHold, isMuted, sessionId } = facade

  const room = useCallSessionRoomStore().getRoom(sessionId)
  const isGroup = room?.isGroup ?? false
  const statuses = computed(() => getParticipantMediaStatus(callId.value))

  const shouldReleaseMic = computed(() => {
    if (isGroup) {
      return Boolean(statuses.value?.isAudioMuted) || isOnHold.value
    }

    return isMuted.value || isOnHold.value
  })

  let unwatch: WatchHandle
  const init = () => {
    unwatch = watch(shouldReleaseMic, (shouldRelease, wasReleased) => {
      if (shouldRelease && !wasReleased) {
        deactivateLocalAudioStream(localAudioStream)
      } else if (!shouldRelease && wasReleased && !localAudioStream.value) {
        storeMediaDevices.replaceMicrophoneOnActiveSessions(undefined, { force: true }).catch(() => {})
      }
    })
  }

  const destroy = () => unwatch?.()

  eventBus.on('callEnded', (endedCallId: string) => {
    if (endedCallId === callId.value) {
      destroy()
    }
  })

  return {
    init,
  }
}
